import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SortService {

  constructor() { }

  public sort = (criteria: SearchCriteria, object: any[]) : any => {
    return object.sort((a, b) => {
      if(criteria.sortDirection === 'desc'){
        if(a[criteria.sortColumn] < b[criteria.sortColumn]){
          return 1;
        }else{
          return -1;
        }

      }
      else {
        if(a[criteria.sortColumn] > b[criteria.sortColumn]){
          return 1;
        }else{
          return -1;
        }
      }
    });

  }

  public getSortedData(data: any[], sortColumn: string, sortDirection: string = 'asc'){
    let criteria: SearchCriteria = new SearchCriteria();
    criteria.sortColumn = sortColumn;
    criteria.sortDirection = sortDirection;
    return this.sort(criteria, data);
  }

}

export class SearchCriteria {
  sortColumn: string;
  sortDirection: string;
}
